import React, {useEffect} from 'react';

import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom";
import Colors from "../utils/colors";

const useStyles = makeStyles(() => ({
  h1: {
    paddingTop: '10%',
    fontWeight: 500,
    fontSize: '56px',
    lineHeight: '66px',
  },
  explaination: {
    fontSize: '30px',
  },
  btnClass: {
    backgroundColor: Colors.darkBlue,
    marginTop: '8%',
    fontSize: '20px',
    padding: '20px 15px'
  },
}));

export default function Error404() {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    document.title = 'Rise by TransAlta Error Page 404';
  }, []);

  const clickedFolder = ()  => {
    history.push('/');
  };

  return (
    <main>
      <h1 className={classes.h1}>Error 404</h1>
      <div className={classes.explaination}>The requested resource does not exist! </div>
      <Button variant="contained"
              color="primary"
              className={classes.btnClass}
              onClick={clickedFolder}
      >
        RETURN TO CURRENT INITIAITIVES
      </Button>
    </main>
  );
}
